export default "__VITE_ASSET__9oHtWaAQ__"